import React from 'react';
import { useTranslation } from 'i18n';
import { TFunction } from 'i18n';

type ValidationSchema = (t: TFunction) => any;

export default function useCreateValidationSchema(
  validationSchema: ValidationSchema,
  t?: TFunction,
) {
  const { t: internalT } = useTranslation();

  const tFunction = t ?? internalT;

  const validationSchemaRef = React.useRef<ValidationSchema>(validationSchema);

  /*React.useEffect(() => {
    validationSchemaRef.current = validationSchema;
  }, [validationSchema]);*/

  return React.useMemo(() => {
    return validationSchemaRef.current(tFunction);
  }, [validationSchemaRef.current, tFunction]);
}
